// An account error in words, with a live countdown when the server said "wait" (rate limits).
// The message names the reason ("one account per hour from each network"), never just "failed".
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Caption } from './ui';
import { useCountdown } from '../hooks';
import { formatCountdown } from '../logic/format';
import { useAccount } from '../store/account';
import { usePalette } from '../theme';

/** Seconds left on the current wait (0 when there is none). Used to disable the button that was refused. */
export function useWait(): number {
  return useCountdown(useAccount(s => s.retryUntil));
}

export default function ErrorNote() {
  const { t } = useTranslation();
  const p = usePalette();
  const { error, retryUntil, clearError } = useAccount();
  const left = useCountdown(retryUntil);
  // When the wait is over the message has done its job: clear it so the button comes back.
  useEffect(() => {
    if (retryUntil && left === 0) clearError();
  }, [retryUntil, left, clearError]);
  if (!error) return null;
  return <Caption color={p.danger}>{t(`account.errors.${error}`, { time: formatCountdown(left) })}</Caption>;
}
